import React from 'react'

import Footer from 'components/_old/Footer/Footer.jsx'

const DesktopFooter = (): React.ReactElement => {
  return <Footer />
}

export { DesktopFooter }
